<template>
  <div ref="formContainer">
    <user-table :users="users" :totalPages="totalPages" :page="page"  @setPage="setPage" :setskeletonLoader="displayLoader"></user-table>
  </div>
</template>

<script>
  import helpers from '@/helpers.js';
  import UserTable from './user_table';
  export default {
    components: {
      UserTable,
    },


    data: function () {
      return {
        product: 0,
        page: 0,
        fullPage: '',
        organization_search: 'all',
        displayLoader: false,
      }
    },


    computed: {
      selectedProduct: function () {
        return this.$store.getters["persist/selectedProduct"];
      },
      users: function () {
        return this.$store.getters['users/users'];
      },

      totalPages: function () {
        return this.$store.getters['users/totalPages'];
      },
      status: function() {
        return this.$store.getters['users/status'];
      },
      type: function() {
        return this.$store.getters['users/type'];
      },
      search: function() {
        return this.$store.getters['users/search'];
      },
      set_selected_org:function() {
        return this.$store.getters['users/setSelectedOrg'];
      }
    },


    created: function () {
      this.page = helpers.getPageQuery();
    },

    mounted: function () {
      // this.setskeletonLoader(true);
      // this.$store.dispatch('users/getusersByType', [this.page, this.status, this.type, this.search, this.set_selected_org])
      //   .then(() => {
      //     this.setskeletonLoader(false);
      //   })
      //   .catch((error) => {
      //     this.setskeletonLoader(false);
      //   });
    },


    watch: {
      page: function (val) {
        this.product = localStorage.getItem('product');

        // let loader = this.$loading.show({
        //   loader: 'dots',
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.setskeletonLoader(true);
        this.$store.dispatch('users/getusersByType', [val,this.status,this.type,this.search,this.set_selected_org])
          .then(() => {
            // Remove the setTimeout and let the watchers handle hiding the loader
            // setTimeout(() => {
            //   this.setskeletonLoader(false);
            // }, 1000);
          })
          .catch((error) => {
            this.setskeletonLoader(false);
          });
      },
      selectedProduct: function () {

        this.product = localStorage.getItem('product');
        
        // let loader = this.$loading.show({
        //   loader: 'dots',
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.setskeletonLoader(true);
        this.$store.dispatch('users/getOrganizationUsers', [1, this.organization_search])
          .then(() => {
            this.setskeletonLoader(false);
          })
          .catch((error) => {
            this.setskeletonLoader(false);
          });
      }
    },


    methods: {
      setPage(page, organization_search) {
        this.page = page;
        this.organization_search = organization_search;
        if(this.$route.query.page != page){
          this.$router.push('users?page=' + page);
        }
      },
      setskeletonLoader(event){
        this.displayLoader = event;
        this.$forceUpdate();
      },
    }
  }
</script>
<style>
  .custom_all {
    position: absolute;
    z-index: 999;
    top: 350px;
    left: 40%;
    opacity: 0.0.5;
  }
</style>